var map;
var markers = [];
var infoWindows = [];
var area = {
    tokyo : {
        lat: 35.6546836,
        lng: 139.3696541
    },
    chiba : {
        lat: 35.68300151,
        lng: 139.9880907
    },
    kanagawa : {
        lat: 35.4706849,
        lng: 139.6690127
    },
    saitama : {
        lat: 35.786981,
        lng: 139.747269
    },
    ibaraki : {
        lat: 36.005885,
        lng: 140.041238
    },
    tohoku: {
        lat: 38.15938671489565, 
        lng: 140.89121862611373
    },
    kansai : {
        lat: 34.730415,
        lng: 135.463169
    },
    chukyo : {
        lat: 35.3082681,
        lng: 136.9602047
    },
    hiroshima : {
        lat: 34.3710642,
        lng: 132.4214249
    },
    kyushu : {
        lat: 33.57944,
        lng: 130.510621
    },
    overseas : {
        lat: 13.52024219,
        lng: 100.9866044
    },
}
$('[data-map-area]').on('click', function(){
    var target = $(this).data('map-area');
    var lat = area[target].lat;
    var lng = area[target].lng;
    
    map.setCenter( new google.maps.LatLng( 
        lat,lng
    ) ) ;
    map.setZoom(10);
    setMarker($(this).data('map-area'));
    return false;
});
function initMap(){
    map = new google.maps.Map(document.getElementById('map'), {
        center: {
            lat: 35.6546836,
            lng: 139.3696541
        },
        zoom: 10,
        maxZoom : 15,
        mapTypeControl: false,
        scrollwheel: false,
    });
    var marker = new google.maps.Marker({
        position: new google.maps.LatLng,
        map: map,
        
    });
    setMarker('tokyo');
}


$('[data-map]').on('click', function(){
    var target = parseInt($(this).attr('href').slice(7));
    console.log(target);
    for (var i = 0; i < infoWindows.length; i++) {
        infoWindows[i].close();
    }
    infoWindows[target].open(markers[target].getMap(), markers[target]);
    map.panTo(markers[target].getPosition());
    return false;
});

function setMarker(type){
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }
    markers = [];
    infoWindows = [];
    var data = mapData[type];
    for (var i = 0; i < data.length; i++) {
        var num = i + 1;
        var pinNo = ( '00' + num ).slice( -2 );
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(data[i]['lat'], data[i]['lng']),
            map: map,
            icon: '../images/logistics/pin/pin_' + data[i]['pin'] + pinNo + '.png'
        });
        var infoWindow = new google.maps.InfoWindow({ // 吹き出しの追加
            
            content:
            '<div class="logistics-popup">' +
            '<div class="logistics-popup-image">' +
            '<img src ="../images/logistics/pin/' + data[i]['image'] + '" alt = "">' +
            '</div>' +
            '<div class="logistics-popup-contents">' +
            '<h3 class="logistics-popup-title">' + data[i]['title'] + '</h3>' +
            '<a href="../logistics/' + data[i]['link'] +'" class="logistics-popup-button">詳しくはこちら</a>' +
            '</div>' +
            '</div>',
            // 吹き出しに表示する内容
            
        });
        markers.push(marker);
        infoWindows.push(infoWindow);

        openInfoWindow(marker, infoWindow);
    }
}

function openInfoWindow(marker, infoWindow){
    google.maps.event.addListener(marker, 'click', function (event) {
        for (var i = 0; i < infoWindows.length; i++) {
            infoWindows[i].close();
        }
        infoWindow.open(marker.getMap(), marker);
        map.panTo(marker.getPosition());
    });
}

var mapData = {
    'tokyo': [
        {
            lat: 35.65537708379185,
            lng: 139.36981619240956,
            title: 'MFLP 日野',
            image:'hino.jpg',
            link: 'mflp-hino/index.html',
            pin:''
        },
        {
            lat: 35.58599213169265,
            lng: 139.76056379126388,
            title: '東京レールゲートEAST',
            image:'tokyo-railgateeast.jpg',
            link: 'tokyo-railgateeast/index.html',
            pin:''
            // link:'pickup/tokyo.html'
        },
        {
            lat: 35.55529084158493,
            lng: 139.75085546759308,
            title: 'MFIP 羽田',
            image:'haneda.jpg',
            link: 'mfip-haneda/index.html',
            pin:''
        },
        {
            lat: 35.71439374032251,
            lng: 139.41155757386431,
            title: 'MFLP 立川立飛',
            image:'tachikawatachihi.jpg',
            link: 'mflp-tachikawatachihi/index.html',
            pin:''
        },
        {
            lat: 35.64533978963671,
            lng: 139.83883817933486,
            title: 'MFLP 新木場Ⅰ',
            image:'shinkiba01.jpg',
            link: 'mflp-shinkiba-1/index.html',
            pin:'undone'
            
        },
        {
            lat: 35.63479367747781,
            lng:  139.82463827888714,
            title: 'MFLP 新木場Ⅱ',
            image:'shinkiba02.jpg',
            link: 'mflp-shinkiba-2/index.html',
            pin:'undone'
        },
        {
            lat: 35.79291816203824, 
            lng: 139.67602038212158,
            title: 'MFLP・LOGIFRONT東京板橋',
            image:'itabashi.jpg',
            link: 'mflp-itabashi/index.htm',
            pin:'undone'
        },
        // {
        //     lat: 東京lat,
        //     lng: 東京lng,
        //     title: '物件',
        //     image:'base.jpg',
        //     link: '/index.html',
        //     pin:'undone'
        // },
    ],
    'chiba': [
        {
            lat: 35.683704887368684, 
            lng: 139.98782735453563,
            title: 'MFLP 船橋Ⅰ',
            image:'funabashi01.jpg',
            link: 'mflp-funabashi/index.html',
            pin:''
        },
        {
            lat: 35.68092194613016,
            lng: 139.98764512499935,
            title: 'MFLP 船橋Ⅱ',
            image:'funabashi02.jpg',
            link: 'mflp-funabashi-2/index.html',
            pin:''
        },
        {
            lat: 35.68965253819384,
            lng: 139.96412019378272,
            title: 'MFLP 船橋西浦',
            image:'funabashinishiura.jpg',
            link: 'mflp-funabashinishiura/index.html',
            pin:''
        },
        {
            lat: 35.66807286845855,
            lng: 139.93475557804288,
            title: 'GLP・MFLP 市川塩浜',
            image:'glp-ichikawasiohama.jpg',
            link: 'glp-mflp-ichikawasiohama/index.html',
            pin:''
        },
        {
            lat: 35.90717833370939,
            lng: 139.94005349985594,
            title: 'MFLP 柏',
            image:'kashiwa.jpg',
            link: 'mflp-kashiwa/index.html',
            pin:''
        },
        {
            lat: 35.80691355434144,
            lng: 140.12482812872284,
            title: 'MFIP 印西',
            image:'inzai.jpg',
            link: 'mfip-inzai/index.html',
            pin:''
        },
        {
            lat: 35.80553586669994, 
            lng: 140.12459258565866,
            title: 'MFIP 印西Ⅱ',
            image:'inzai02.jpg',
            link: 'mfip-inzai-2/index.html',
            pin:''
        },
        {
            lat: 35.68057663965304,
            lng: 139.98917265466707,
            title: 'MFLP 船橋Ⅲ',
            image: 'funabashi03.jpg',
            link: 'mflp-funabashi-3/index.html',
            pin:''
            // link:'pickup/funabashi03.html'
        },
        {
            lat: 35.669486326451064,
            lng: 139.94137370535643,
            title: 'MFLP 市川塩浜Ⅱ',
            image:'ichikawasiohama.jpg',
            link: 'ichikawasiohama-plan/index.html',
            pin:''
        },
        {
            lat: 35.73217878056753,
            lng: 140.1326866881606,
            title: 'MFLP 八千代勝田台',
            image:'yachiyo.jpg',
            link: 'mflp-yachiyo/index.html',
            pin:''
        },
        {
            lat: 35.69692342064743,
            lng:  139.97014061304242,
            title: 'MFLP 船橋南海神',
            image:'funabashiminami.jpg',
            link: 'mflp-funabashiminami/index.html',
            pin:'undone'
        },
        // {
        //     lat: 千葉lat,
        //     lng: 千葉lng,
        //     title: '物件',
        //     image:'base.jpg',
        //     link: '/index.html',
        //     pin:'undone'
        // },
    ],
    'kanagawa': [
        {
            lat: 35.47082997408151,
            lng: 139.6698908538353,
            title: 'MFLP 横浜大黒',
            image:'yokohamadaikoku.jpg',
            link: 'mflp-yokohamadaikoku/index.html',
            pin:''
        },
        {
            lat: 35.52028090456954,
            lng: 139.34307179113046,
            title: 'MFLP 厚木',
            image:'atsugi.jpg',
            link: 'mflp-atsugi/index.html',
            pin:''
        },
        {
            lat: 35.42118341640751,
            lng: 139.33635066069215,
            title: 'MFLP 厚木Ⅱ',
            image:'atsugi02.jpg',
            link: 'mflp-atsugi-2/index.html',
            pin:''
        },
        {
            lat: 35.35426078766756,
            lng: 139.34484237481317,
            title: 'MFLP 平塚',
            image:'hiratsuka.jpg',
            link: 'mflp-hiratsuka-1/index.html',
            pin:''
        },
        {
            lat: 35.39409297093316,
            lng: 139.36054548334906,
            title: 'MFLP 平塚Ⅱ',
            image:'hiratsuka02.jpg',
            link: 'mflp-hiratsuka-2/index.html',
            pin:''
        },
        
        {
            lat: 35.530393815879606,
            lng: 139.71060067643958,
            title: 'MFLP 川崎Ⅰ',
            image:'kawasaki.jpg',
            link: 'mflp-kawasaki/index.html',
            pin:''
        },
        {
            lat: 35.52022933932123,
            lng: 139.5523670758155,
            title: 'MFLP 横浜港北',
            image:'yokohamakouhoku.jpg',
            link: 'mflp-yokohamakouhoku/index.html',
            pin:''
        },
        {
            lat: 35.434768877590614,
            lng: 139.37857816435155,
            title: 'MFLP 海老名Ⅰ',
            image: 'ebina.jpg',
            link: 'mflp-ebina/index.html',
            pin:'undone'
            // link:'pickup/ebina01.html'
        },
        {
            lat: 35.44689047933031,
            lng: 139.41976594986315,
            title: 'MFLP 東名綾瀬',
            image:'toumeiayase.jpg',
            link:'mflp-toumeiayase/index.html',
            pin:'undone'
        },
        {
            lat: 35.40379552951748,
            lng: 139.39942625249822,
            title: 'MFLP 海老名南',
            image:'ebinaminami.jpg',
            link:'mflp-ebinaminami/index.html',
            pin:'undone'
        },
        {
            lat: 35.39413928707462,
            lng: 139.36233346800654,
            title: 'MFLP 平塚Ⅲ',
            image:'hiratsuka03.jpg',
            link:'mflp-hiratsuka-3/index.html',
            pin:'undone'
            
        },
        
        {
            lat: 35.488602,
            lng: 139.407563,
            title: 'MFLP 座間',
            image:'zama.jpg',
            link:'mflp-zama/index.html',
            pin:'undone'
        },
        // {
        //     lat: 35.446429196324374, 
        //     lng: 139.39310352642244,
        //     title: 'MFIP 海老名',
        //     image:'mfip-ebina.jpg',
        //     link: 'mfip-ebina/index.html',
        //     pin:'undone'
        // },
        // {
        //     lat: 神奈川lat,
        //     lng: 神奈川lng,
        //     title: '物件',
        //     image:'base.jpg',
        //     link: '/index.html',
        //     pin:'undone'
        // },
    ],
    'saitama': [
        {
            lat: 35.78771682854965,
            lng: 139.74784892890239,
            title: 'MFLP 川口Ⅰ',
            image:'kawaguchi.jpg',
            link: 'mflp-kawaguchi/index.html',
            pin:''
        },
        {
            lat: 35.88703499903333,
            lng: 139.45136000363738,
            title: 'MFLP プロロジスパーク川越',
            image:'kawagoe.jpg',
            link: 'mflp-prologisparkkawagoe/index.html',
            pin:''
        },
        {
            lat: 35.83245629836015,
            lng: 139.8138592329457,
            title: 'MFLP 八潮',
            image:'yashio.jpg',
            link: 'mflp-yashio/index.html',
            pin:''
        },
        {
            lat: 36.071906741367144,
            lng: 139.63099411464452,
            image:'kuki.jpg',
            title: 'MFLP 久喜',
            link: 'mflp-kuki/index.html',
            pin:''
        },
        {
            lat: 35.86093859844399, 
            lng: 139.84839763518377,
            image:'misato.jpg',
            title: 'MFLP 三郷',
            link: 'mflp-misato/index.html',
            pin:'undone'
        },
        {
            lat: 35.82732401523589, 
            lng: 139.5384411439041,
            image:'tokorozawa.jpg',
            title: 'MFLP 所沢',
            link: 'mflp-tokorozawa/index.html',
            pin:''
        },
        // {
        //     lat: 35.81243822637813,
        //     lng:  139.3758784432336,
        //     title: 'MFLP 入間Ⅰ',
        //     image:'iruma.jpg',
        //     link: 'mflp-iruma01/index.html',
        //     pin:'undone'
        // },
        // {
        //     lat: 35.851038403866546, 
        //     lng: 139.35209485537638,
        //     title: 'MFLP 入間Ⅱ',
        //     image:'iruma02.jpg',
        //     link: 'mflp-iruma02/index.html',
        //     pin:'undone'
        // },
        // {
        //     lat: 埼玉lat,
        //     lng: 埼玉lng,
        //     title: '物件',
        //     image:'base.jpg',
        //     link: '/index.html',
        //     pin:'undone'
        // },
    ],
    'ibaraki': [
        {
            lat: 36.00653343940539, 
            lng: 140.0425910087199,
            title: 'MFLP つくば',
            image:'tsukuba.jpg',
            link: 'mflp-tsukuba/index.html',
            pin:''
        },
        {
            lat: 36.032810421154075,
            lng: 140.04426795169095,
            title: 'MFLP つくばみらい',
            image:'tsukubamirai.jpg',
            link: 'mflp-tsukubamirai/index.html',
            pin:'undone'
        },
        // {
        //     lat: 茨城lat,
        //     lng: 茨城lng,
        //     title: '物件',
        //     image:'base.jpg',
        //     link: '/index.html',
        //     pin:'undone'
        // },
    ],
    'tohoku': [
        {
            lat: 38.15938671489565, 
            lng: 140.89121862611373,
            title: 'MFLP 仙台名取Ⅰ',
            image:'sendai.jpg',
            link: 'mflp-sendai/index.html',
            pin:'undone'
        },
        // {
        //     lat: 東北lat,
        //     lng: 東北lng,
        //     title: '物件',
        //     image:'base.jpg',
        //     link: '/index.html',
        //     pin:'undone'
        // },
    ],
    'kansai': [
        {
            lat: 34.596158722631145,
            lng: 135.46093580009963,
            title: 'MFLP 堺',
            image:'sakai.jpg',
            link: 'mflp-sakai/index.html',
            pin:''
        },
        {
            lat: 34.7289040532753,
            lng: 135.46304607923807,
            title: 'MFLP 大阪Ⅰ',
            image:'osaka.jpg',
            link: 'mflp-oosaka-1/index.html',
            pin:''
        },
        {
            lat: 34.85779156403536,
            lng: 135.53811416203735,
            title: 'MFLP 茨木',
            image:'ibaraki.jpg',
            link: 'mflp-ibaraki/index.html',
            pin:''
        },
        {
            lat: 34.77555901901256,
            lng: 135.663143850364,
            title: 'MFLP 大阪交野',
            image:'osakakatano.jpg',
            link: 'mflp-oosakakatano/index.html',
            pin:''
        },
        {
            lat: 34.678214703375104, 
            lng: 135.42371254232845,
            title: 'MFLP・OGUD大阪酉島',
            image: 'torishima.jpg',
            link: 'mflp-oosakatorishima/index.html',
            pin:'undone'
        },
        {
            lat: 34.715483840269805,
            lng:  135.405199943162,
            title: 'MFLP 尼崎Ⅰ',
            image:'amagasaki.jpg',
            link: 'mflp-amagasaki/index.html',
            pin:'undone'
        },
        // {
        //     lat: 関西lat,
        //     lng: 関西lng,
        //     title: '物件',
        //     image:'base.jpg',
        //     link: '/index.html',
        //     pin:'undone'
        // },

    ],
    'chukyo': [
        {
            lat: 35.307838657599035,
            lng: 136.96015478538405,
            title: 'MFLP 小牧',
            image: 'komaki.jpg',
            link: 'mflp-komaki/index.html',
            pin:''
        },
        {
            lat: 35.23629727414858,
            lng: 136.8154126736111,
            title: 'MFLP 稲沢',
            image: 'inazawa.jpg',
            link: 'mflp-inazawa/index.html',
            pin:''
        },
        {
            lat: 35.046237560356325,
            lng: 136.75499970888424,
            title: 'MFLP 弥富木曽岬',
            image: 'yatomikisosaki.jpg',
            link: 'mflp-yatomikisosaki/index.html',
            pin:'undone'
        },
        {
            lat: 35.26558817838806, 
            lng: 136.85632699991098,
            title: 'MFLP 名古屋岩倉',
            image: 'iwakura.jpg',
            link: 'mflp-iwakura/index.html',
            pin:'undone'
        },
        {
            lat: 35.28174364440467, 
            lng: 136.7800913076004,
            title: 'MFLP 一宮',
            image: 'ichinomiya.jpg',
            link: 'mflp-ichinomiya/index.html',
            pin:'undone'
        },
        // {
        //     lat: 中京lat,
        //     lng: 中京lng,
        //     title: '物件',
        //     image:'base.jpg',
        //     link: '/index.html',
        //     pin:'undone'
        // },
        
    ],
    'hiroshima': [
        {
            lat: 34.371215533501584,
            lng: 132.4235015965619,
            title: 'MFLP 広島Ⅰ',
            image:'hiroshima.jpg',
            link: 'mflp-hiroshima-1/index.html',
            pin:''
        },
        // {
        //     lat: 広島lat,
        //     lng: 広島lng,
        //     title: '物件',
        //     image:'base.jpg',
        //     link: '/index.html',
        //     pin:'undone'
        // },
    ],
    'kyushu': [
        {
            lat: 33.5778084375494,
            lng: 130.51561242635563,
            title: 'MFLP 福岡Ⅰ',
            image: 'fukuoka.jpg',
            link: 'mflp-fukuoka-1/index.html',
            pin:''
        },
        // {
        //     lat: 33.38787169121599,
        //     lng: 130.52786357787681,
        //     title: 'MFLP 鳥栖',
        //     image: 'tosu.jpg',
        //     link: 'mflp-tosu/index.html',
        //     pin:''
        // },
        {
            lat: 33.62488471055382,
            lng: 130.4860956232327,
            title: 'MFLP・SGリアルティ福岡粕屋',
            image: 'kasuyamachi.jpg',
            link: 'kasuyamachi-plan/index.html',
            pin:'undone'
        },
        // {
        //     lat: 九州lat,
        //     lng: 九州lng,
        //     title: '物件',
        //     image:'base.jpg',
        //     link: '/index.html',
        //     pin:'undone'
        // },
    ],
    'overseas': [
        {
            lat: 13.528461834744459,
            lng: 100.98312386889184,
            title: 'バーンナー2 ロジスティクスパークⅡ期',
            image: 'bangpakong.jpg',
            link: 'bangpakong/index.html',
            pin:''
        },
        // {
        //     lat: 海外lat,
        //     lng: 海外lng,
        //     title: '物件',
        //     image:'base.jpg',
        //     link: '/index.html',
        //     pin:'undone'
        // },
    ]
}